/**
 * @file
 * Alerts script.
 */

(function alertsScript($, Drupal, _, drupalSettings) {
  'use strict';

  var $alerts = $('.alerts, .notification');

  /**
   * Extract the tracker cookie name and value for the container element.
   *
   * TODO: Assumes only 1 tracker withing the container.
   *
   * @param {Object} $container
   *   The container jQuery object.
   *
   * @return {Object}
   *   An object with the following for the first tracker found:
   *   'name': The name of the cookie.
   *   'value': The current value of the cookie, null if not set.
   */
  var getAlertsTrackerCookie = function ($container) {
    var cookie = {
      name: '',
      value: null
    };

    if ('cookie' in $) {
      $('[data-alert-tracker-id]', $container).first().each(function () {
        var $t = $(this);
        cookie.name = 'pinAlert' + $t.data('alertTrackerId');

        var cookieValue = $.cookie(cookie.name);
        if (typeof cookieValue !== 'undefined') {
          cookie.value = cookieValue;
        }

        return false;
      });
    }

    return cookie;
  };

  /**
   * Set the tracker cookie name and value for the container element.
   *
   * TODO: Assumes only 1 tracker withing the container.
   *
   * @param {Object} $container
   *   The container jQuery object.
   *
   * @return {Object}
   *   An object with the following for the first tracker found:
   *   'name': The name of the cookie.
   *   'value': The current value of the cookie, null if not set.
   */
  var setAlertsTrackerCookie = function ($container) {
    var cookie = getAlertsTrackerCookie($container);
    if (cookie.name) {
      cookie.value = 1;
      $.cookie(cookie.name, cookie.value, {
        path: drupalSettings && drupalSettings.path ? (drupalSettings.path.baseUrl || '/') : '/',
        expires: 365,
        secure: true
      });
    }

    return cookie;
  };

  var calculateOffset = function ($container) {
    // Set offset based on the negative of the current
    // CSS bottom value plus the height of the alert.
    var currentBottom = parseInt($container.css('bottom'), 10);
    var alertHeight = $container.height();
    var alertOffset = (alertHeight - currentBottom) * -1;
    return alertOffset;
  };

  var prepareAlert = function ($container, alertOffset) {
    $container
      .css({
        bottom: alertOffset,
        display: 'block',
        visibility: 'hidden'
      })
      .attr('tabindex', -1)
      .attr('aria-hidden', 'true');
    // Check if a cookie is set against it.
    var cookie = getAlertsTrackerCookie($container);
    if (cookie.value) {
      disableAlert($container);
    }
  };

  var displayAlert = function ($container, alertOffset) {
    if ($container.hasClass('alerts--active')) {
      var $window = $(window);
      var $document = $(document);
      var displayHeight = $.type($container.data('alertDisplayHeight')) !== 'undefined' ? $container.data('alertDisplayHeight') : $window.height();
      var scrollPosition = $document.scrollTop();
      if (scrollPosition >= displayHeight) {
        // We add an amination class here to set transition in CSS
        // and avoid an animating alerts box on initial page load.
        $container.addClass('alerts--anim')
          .css({
            bottom: 0,
            visibility: 'visible'
          })
          .attr('aria-hidden', 'false')
          .attr('tabindex', 0);
      }
      else {
        $container
          .css('bottom', alertOffset)
          .attr('aria-hidden', 'true')
          .attr('tabindex', -1);
      }
    }
  };

  var dismissAlert = function ($container, alertOffset) {
    $container
      .css('bottom', alertOffset)
      .attr('aria-hidden', 'true')
      .attr('tabindex', -1)
      .delay(700).hide(0);
    setAlertsTrackerCookie($container);
    disableAlert($container);
    activateNextAlert($alerts);
  };

  var disableAlert = function ($container) {
    $container.addClass('alerts--disabled');
    $container.removeClass('alerts--active');
  };

  var activateAlert = function ($container) {
    $container.addClass('alerts--active');
  };

  var activateNextAlert = function ($alerts) {
    // Find the first alert not disabled and activate it.
    $alerts.not('.alerts--disabled').first().each(function () {
      var $container = $(this);
      activateAlert($container);
    });
  };


  /*
   * Alerts behaviors.
   */
  Drupal.behaviors.alertsSlide = {
    attach: function (context) {
      $alerts.each(function (index) {
        var $container = $(this);
        var alertOffset = calculateOffset($container);
        prepareAlert($container, alertOffset);
        // Slide up/down the alert based on scroll position in the viewport.
        $(window).on('scroll', _.debounce(function () {
          displayAlert($container, alertOffset);
        }, 15));
        // Set an event to dismiss the alert.
        $container.find('.js-alerts__close-button').click(function () {
          dismissAlert($container, alertOffset);
        });
      });
      activateNextAlert($alerts);
      // Trigger the scroll event.
      $(window).scroll();
    }
  };

  /*
   * Hide placeholder on input click.
   */
  Drupal.behaviors.placeholderHide = {
    attach: function (context) {
      var $alerts_input = $('.alerts input');
      if ($alerts_input.length > 0) {
        $alerts_input.on('click', function () {
          $(this).removeAttr('placeholder');
        });
      }
    }
  };

  /*
   * Newsletter validation mechanism.
   */
  Drupal.behaviors.NewsletterValidation = {
    isValidEmailAddress: function (emailAddress) {
      var pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/; // eslint-disable-line no-useless-escape
      return pattern.test(emailAddress);
    },
    setSubmitStatus: function ($input, $submit) {
      var input_val = $input.val();
      var valid_email = Drupal.behaviors.NewsletterValidation.isValidEmailAddress(input_val);

      // If input not empty or is not valid email, disable sumit.
      if (input_val.length === 0 || !valid_email) {
        $submit.addClass('disabled');
      }
      // otherwise enable by removing disabled class.
      else {
        // otherwise enable by removing disabled class.
        $submit.removeClass('disabled');
      }
    },
    attach: function (context) {
      var $newsletter_form = $('aside.alerts--newsletter');

      // Check if newsletter form is on the page.
      if ($newsletter_form.length > 0) {
        var $input = $newsletter_form.find('input#edit-email');
        var $submit = $newsletter_form.find('.button--go');

        // Set default status based if input is autocompleted in future case.
        Drupal.behaviors.NewsletterValidation.setSubmitStatus($input, $submit);

        // On keyup event, while typing the e-mail decide whenever to enable
        // the submit.
        $input.keyup(function () {
          Drupal.behaviors.NewsletterValidation.setSubmitStatus($(this), $submit);
        });

      }
    }
  };


}(jQuery, Drupal, _, drupalSettings));
